/** The selected, editable `@` chip, built in the field's writeValue. */
export const STANDALONE_CHIP_CLASS =
  "standalone-bar-chip ml-0.5 mr-1.5 inline-flex max-w-full items-baseline gap-1 whitespace-nowrap align-baseline text-appkit-body leading-5 text-secondary select-all";
export const STANDALONE_CHIP_ICON_CLASS = "inline-flex h-3 w-3 shrink-0 self-center";
export const STANDALONE_CHIP_LABEL_CLASS = "min-w-0 truncate font-medium";
